import i18n from "src/i18n/config";
import { z } from "zod";

import { SimplePolicyRule } from "../types";

const mirroringProperty = { command: "changeProperty", property: "persist.sys.vncr.enabled" };
const screenMirroringSchema = z.object({ enabled: z.boolean() });

// The property is written as the numeric flag the VNC server reads, not as "true"/"false".
const toEnabled = (value: unknown) => (value === "1" ? true : value === "0" ? false : undefined);

export const screenMirroring: SimplePolicyRule<z.infer<typeof screenMirroringSchema>> = {
    id: "screenMirroring",
    title: () => i18n.t("modals:addRule.rules.screenMirroring.title"),
    description: () => i18n.t("modals:addRule.rules.screenMirroring.description"),
    details: () => i18n.t("modals:addRule.rules.screenMirroring.details"),
    summary: (_, { enabled }) =>
        enabled
            ? i18n.t("modals:addRule.rules.screenMirroring.summaryEnabled")
            : i18n.t("modals:addRule.rules.screenMirroring.summaryDisabled"),
    categories: ["display"],
    fields: [{ type: "boolean", name: "enabled", label: () => i18n.t("common:label.enabled") }],
    defaultValues: { enabled: true },
    schema: screenMirroringSchema,
    command: mirroringProperty,
    toValues: ({ enabled }) => (enabled ? "1" : "0"),
    fromValues: (value) => ({ enabled: toEnabled(value) }),
    requiredFeature: {
        type: "StreamSessionLimit",
        message: () => i18n.t("modals:addRule.rules.screenMirroring.unavailable"),
    },
    flags: [],
};
